/**
 * Waits for window.whatever external JS singleton to exist then returns it
 */
export function getWindowPropAsync<PropType>(
    windowPropName: string,
    checkIntervalMs: number = 10
): Promise<PropType> {
    return new Promise((resolve, reject) => {
        if (typeof window[windowPropName] === 'object') {
            // If it already exists, return it now.
            resolve(window[windowPropName]);
        } else {
            // If it doesn't yet exist check every so often until it does and return it.
            const checkInterval = setInterval(() => {
                if (typeof window[windowPropName] === 'object') {
                    clearInterval(checkInterval);
                    resolve(window[windowPropName]);
                }
            },
                checkIntervalMs
            );
        }
    });
}
